import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// View Components
import Menu from './views/Menu.vue'
import Announcement from './views/Announcement.vue'
import VennDiagramDePon from './views/VennDiagramDePon.vue'
import Preferences from './views/Preferences.vue'
import QueryMonkeyC from './views/QueryMonkeyC.vue'
import QueryMonkeyI from './views/QueryMonkeyI.vue'
import QueryMonkeyS from './views/QueryMonkeyS.vue'
import QueryMonkeyD from './views/QueryMonkeyD.vue'
import QueryMonkeyT from './views/QueryMonkeyT.vue'
import QueryPuddingI from './views/QueryPuddingI.vue'
import QueryPuddingS from './views/QueryPuddingS.vue'
import QueryPuddingC from './views/QueryPuddingC.vue'
import QueryAnemonefishS from './views/QueryAnemonefishS.vue'
import QueryAnemonefishI from './views/QueryAnemonefishI.vue'
import QueryActiniaI from './views/QueryActiniaI.vue'
import QueryLionI from './views/QueryLionI.vue'
import QueryLionS from './views/QueryLionS.vue'
import QueryLionC from './views/QueryLionC.vue'
import QueryTigerI from './views/QueryTigerI.vue'
import QueryTigerS from './views/QueryTigerS.vue'
import QueryTigerC from './views/QueryTigerC.vue'
import QueryMilkTea from './views/QueryMilkTea.vue'
import QueryUmaoiI from './views/QueryUmaoiI.vue'
import QueryUmaoiS from './views/QueryUmaoiS.vue'
import QueryRoots from './views/QueryRoots.vue'
import QueryRootsDetail from './views/QueryRootsDetail.vue'
import QueryGourami from './views/QueryGourami.vue'
import QueryTapirMk from './views/QueryTapirMk.vue'
import QueryTapirMd from './views/QueryTapirMd.vue'
import QueryShinTapir from './views/QueryShinTapir.vue'
import QueryUmbrellaI from './views/QueryUmbrellaI.vue'
import QueryKumquatI from './views/QueryKumquatI.vue'
import QueryTempuraI from './views/QueryTempuraI.vue'
// POS
import QueryChocostickI from './views/QueryChocostickI.vue'
import QueryChocostickS from './views/QueryChocostickS.vue'
import QueryChocostickM from './views/QueryChocostickM.vue'
import QueryChocostickT from './views/QueryChocostickT.vue'
import QueryChocostickH from './views/QueryChocostickH.vue'
import QueryElkI from './views/QueryElkI.vue'
import QueryElkS from './views/QueryElkS.vue'
import QueryMarmotI from './views/QueryMarmotI.vue'
import QueryShrimp from './views/QueryShrimp.vue'
import QueryMousePosDownloadRequest from './views/QueryMousePosDownloadRequest.vue'
import QueryMousePos from './views/QueryMousePos.vue'
import QueryMousePosLegacy from './views/QueryMousePosLegacy.vue'
//
import QueryHeron from './views/QueryHeron.vue'
import QueryRiver from './views/QueryRiver.vue'

import Pfv from './views/Pfv.vue'
import QueryManagement from './views/QueryManagement.vue'
import Stats from './views/Stats.vue'
import CustomerZipGroup from './views/CustomerZipGroup.vue'
import Card from './views/Card.vue'
import Omatome from './views/Omatome.vue'
import UserCustomerAttribute from './views/UserCustomerAttribute.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'menu',
      component: Menu,
      meta: { page: { title: 'メニュー' } },
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
      meta: { page: { title: 'お知らせ' } },
    },
    {
      path: '/pfv',
      name: 'pfv',
      component: Pfv,
      meta: {
        page: { title: '顧客PFV参照', hasHelp: true },
        requiredServices: ['idpos'],
      },
    },
    {
      path: '/query-management',
      name: 'query-management',
      component: QueryManagement,
      meta: { page: { title: '分析履歴' } },
    },
    {
      path: '/pon',
      name: 'pon',
      component: VennDiagramDePon,
      meta: {
        page: { title: 'ベン図でポン！', hasHelp: true },
        requiredServices: ['idpos'],
      },
    },
    {
      path: '/stats',
      name: 'stats',
      component: Stats,
      meta: { page: { title: '分析回数' }, admin: true },
    },
    {
      path: '/zip',
      name: 'zip',
      component: CustomerZipGroup,
      meta: { page: { title: '郵便番号集計' }, admin: true },
    },
    {
      path: '/card',
      name: 'card',
      component: Card,
      meta: { page: { title: 'カードID相互変換' }, admin: true },
    },
    {
      path: '/omatome',
      name: 'omatome',
      component: Omatome,
      meta: { page: { title: 'おまとめ' } },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: Preferences,
      meta: { page: { title: '個人設定', hasHelp: false } },
    },
    {
      path: '/user-customer-attribute-upload',
      name: 'user-customer-attribute-upload',
      component: UserCustomerAttribute,
      meta: { page: { title: '顧客属性アップロード' }, admin: true },
    },
    {
      path: '/query-monkey-c/:queryId?',
      name: 'query-monkey-c',
      component: QueryMonkeyC,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-monkey-s/:queryId?',
      name: 'query-monkey-s',
      component: QueryMonkeyS,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-monkey-i/:queryId?',
      name: 'query-monkey-i',
      component: QueryMonkeyI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-monkey-d/:queryId?',
      name: 'query-monkey-d',
      component: QueryMonkeyD,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-monkey-t/:queryId?',
      name: 'query-monkey-t',
      component: QueryMonkeyT,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-pudding-i/:queryId?',
      name: 'query-pudding-i',
      component: QueryPuddingI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-pudding-s/:queryId?',
      name: 'query-pudding-s',
      component: QueryPuddingS,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-pudding-c/:queryId?',
      name: 'query-pudding-c',
      component: QueryPuddingC,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-anemonefish-s/:queryId?',
      name: 'query-anemonefish-s',
      component: QueryAnemonefishS,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-anemonefish-i/:queryId?',
      name: 'query-anemonefish-i',
      component: QueryAnemonefishI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-actinia-i/:queryId?',
      name: 'query-actinia-i',
      component: QueryActiniaI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-lion-i/:queryId?',
      name: 'query-lion-i',
      component: QueryLionI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-lion-s/:queryId?',
      name: 'query-lion-s',
      component: QueryLionS,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-lion-c/:queryId?',
      name: 'query-lion-c',
      component: QueryLionC,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-tiger-i/:queryId?',
      name: 'query-tiger-i',
      component: QueryTigerI,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-tiger-s/:queryId?',
      name: 'query-tiger-s',
      component: QueryTigerS,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-tiger-c/:queryId?',
      name: 'query-tiger-c',
      component: QueryTigerC,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-milk-tea/:queryId?',
      name: 'query-milk-tea',
      component: QueryMilkTea,
      props: true,
      meta: { page: { hasHelp: true } },
    },
    {
      path: '/query-umaoi-i/:queryId?',
      name: 'query-umaoi-i',
      component: QueryUmaoiI,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-umaoi-s/:queryId?',
      name: 'query-umaoi-s',
      component: QueryUmaoiS,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-roots/:queryId?',
      name: 'query-roots',
      component: QueryRoots,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-roots-detail/:queryId?',
      name: 'query-roots-detail',
      component: QueryRootsDetail,
      meta: {
        page: {},
      },
    },
    {
      path: '/query-gourami/:queryId?',
      name: 'query-gourami',
      component: QueryGourami,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-tapir-mk/:queryId?',
      name: 'query-tapir-mk',
      component: QueryTapirMk,
      props: true,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-tapir-md/:queryId?',
      name: 'query-tapir-md',
      component: QueryTapirMd,
      props: false,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-shin-tapir/:queryId?',
      name: 'query-shin-tapir',
      component: QueryShinTapir,
      props: false,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-umbrella-i/:queryId?',
      name: 'query-umbrella-i',
      component: QueryUmbrellaI,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-kumquat-i/:queryId?',
      name: 'query-kumquat-i',
      component: QueryKumquatI,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-tempura-i/:queryId?',
      name: 'query-tempura-i',
      component: QueryTempuraI,
      props: true,
      meta: {
        page: { hasHelp: true },
      },
    },
    {
      path: '/query-chocostick-i/:queryId?',
      name: 'query-chocostick-i',
      component: QueryChocostickI,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-chocostick-s/:queryId?',
      name: 'query-chocostick-s',
      component: QueryChocostickS,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-chocostick-m/:queryId?',
      name: 'query-chocostick-m',
      component: QueryChocostickM,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-chocostick-t/:queryId?',
      name: 'query-chocostick-t',
      component: QueryChocostickT,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-chocostick-h/:queryId?',
      name: 'query-chocostick-h',
      component: QueryChocostickH,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-marmot-i/:queryId?',
      name: 'query-marmot-i',
      component: QueryMarmotI,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-elk-i/:queryId?',
      name: 'query-elk-i',
      component: QueryElkI,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-elk-s/:queryId?',
      name: 'query-elk-s',
      component: QueryElkS,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-shrimp/:queryId?',
      name: 'query-shrimp',
      component: QueryShrimp,
      meta: {
        page: { hasHelp: false },
      },
    },
    {
      path: '/query-mouse-pos',
      name: 'query-mouse-pos',
      component: QueryMousePosDownloadRequest,
      meta: {
        page: { title: 'データダウンロード', hasHelp: false },
      },
    },
    {
      path: '/query-mouse-pos-create/:requestId?',
      name: 'query-mouse-pos-create',
      component: QueryMousePos,
      meta: {
        page: { title: 'データダウンロード', hasHelp: false },
      },
    },
    {
      path: '/query-mouse-pos-legacy',
      name: 'query-mouse-pos-legacy',
      component: QueryMousePosLegacy,
      meta: {
        page: { title: 'データダウンロード（レガシー）', hasHelp: false },
      },
    },
    {
      path: '/query-river/:queryId?',
      name: 'query-river',
      component: QueryRiver,
      meta: {
        page: { title: '売場分析', hasHelp: false },
      },
    },
    {
      path: '/query-heron/:queryId?',
      name: 'query-heron',
      component: QueryHeron,
      meta: {
        page: { title: 'Heron', hasHelp: false },
      },
    },
    {
      path: '/about',
      name: 'about',
      meta: { page: { title: 'About' } },
      // ルート単位でのコード分割
      // ビルドしたときにメインのスクリプトとは別に `about.[hash].js` がこのルート用に作成されます。
      // このルートを表示するときになって初めてロードされるので、使用頻度が低いルートの場合は
      // こうしておくとパフォーマンス、ビルドしたjsのファイルサイズ削減に役立ちます。
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      // 共通で使うUIエレメントの載せる（開発時に見るページです。）
      path: '/ui-elements',
      name: 'ui-elements',
      component: () => import('./views/UiElements.vue'),
    },
    {
      // SPAをサーバーにデプロイするとき、どのパスでもとりあえずindex.htmlを返すように設定します。
      // ※ 例えば、/help/ponでリロードするとサーバーには/help/ponのURLでリクエストする。
      //    そういうときもサーバーでちゃんとindex.htmlを返さないと404になってしまう。
      // このRouterでパスが見つからない場合<router-view>に何も表示されないことになってしまう
      // ので、どのルートにもマッチしなかった場合は404用のコンポーネントを描画します。
      path: '*',
      component: NotFound,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const account = store.state.account

  if (to.meta.requiredServices) {
    for (const s of to.meta.requiredServices) {
      if (!account.services.includes(s)) {
        next({ path: '/' })
        return
      }
    }
  }

  if (to.meta && to.meta.admin) {
    if (!account.roles.includes('admin')) {
      next({
        path: '/',
      })
      return
    }
  }

  setDocumentTitle(to, store.state.menus)

  next()
})

/**
 * meta.page.titleに設定されている文字列をdocument.titleとします。
 * ただし、分析画面のルートはnameだけ定義していて、to.meta.page.titleは定義していません。
 * その場合はメニュー一覧からtoのメニューを探してその日本語名を設定します。
 *
 * 何れもマッチしない場合、document.titleには何も設定されません。
 *
 * @param {Object} to
 * @param {Array} queryMenus
 */
function setDocumentTitle(to, queryMenus) {
  if (to.meta && to.meta.page && to.meta.page.title) {
    document.title = `${to.meta.page.title}`
    return
  }

  if (to.name.startsWith('query-')) {
    if (queryMenus.length === 0) {
      throw new Error(
        'メニューがFetchされていない状態で分析画面がリクエストされました。',
      )
    }

    const menuCode = to.name.substr('query-'.length)
    const menu = queryMenus.find(m => m.menuCode === menuCode)

    if (menu) {
      document.title = menu.menuLongName
    }
  }
}

export default router
